import React, { Component } from 'react';
import { Icon, Form, Button, Modal, Table, Segment } from 'semantic-ui-react';
import Comment from './Comment';
class Suit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            docDetails: [],
            actionDetails: [],
            clients: [],
            docs: true
        };
    }

    handleSubmit = (data) => {
        data['documentType'] = null;
        this.props.handleSubmit(data, '', true)
    }

    render() {
        return (
            <Modal size="large" open={this.props.open} onClose={this.props.close} closeIcon>
                <Modal.Header>Resolve Suit Request</Modal.Header>
                <Modal.Content>
                    <Table inverted className="grey celled striped small" >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Consumer’s Name [Format: Lastname, Firstname]" data-position="top left">Lastname, First Name</Table.HeaderCell>
                                <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="top left">Client Acct#</Table.HeaderCell>
                                <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="top left">Our Acct#</Table.HeaderCell>
                                <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Current Total Due" data-position="top left">Total</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>{this.props.data.conLastName + ", " + this.props.data.conFirstName}</Table.Cell>
                                <Table.Cell>{this.props.data.acoInvoiceId}</Table.Cell>
                                <Table.Cell>{this.props.data.acoAccountId}</Table.Cell>
                                <Table.Cell textAlign='right'>{this.props.data.acoTotal}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    <Segment.Group className="ui horizontal segments">
                        <Segment>
                            <Button className="ui icon labeled small button" style={{ display: "none" }}>
                                <Icon name="gavel"></Icon>
                                View Suit Details
                            </Button>
                        </Segment>
                        <Segment>
                            <Form>
                                <Form.Field inline>
                                    <label>Proceed with suit?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <Button.Group className="small">
                                            <Button positive={!this.props.authSuit} onClick={() => { this.props.suitYesNo(false) }}>No</Button>
                                            <Button.Or />
                                            <Button positive={this.props.authSuit} onClick={() => { this.props.suitYesNo(true) }}>Yes</Button>
                                        </Button.Group>
                                    </label>
                                </Form.Field>
                            </Form>
                        </Segment>
                    </Segment.Group>
                    <Comment {...this.props} type="suit" history={this.props.history} handleSubmit={this.props.handleSubmit} data={[this.props.data]} docRequestPending={['H']} />
                </Modal.Content>
                <Modal.Actions>
                    <Button.Group width={2} className="small buttons">
                        <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                        <Button.Or />
                        <Button positive onClick={this.handleSubmit.bind(this, this.props.data)}>{this.props.t("submit")}</Button>
                    </Button.Group>
                </Modal.Actions>
            </Modal>
        );
    }
}
export default Suit;


// WEBPACK FOOTER //
// ./src/app/ui/alerts/Suit.js